<template>
  <div
    :id="id"
    class="modal-add-trigger"
  >
    <p class="title">Add Trigger Event</p>

    <b-form :class="{'error-input' : $v.dataSetup.triggerName.$error}">
      <label>Name</label>
      <j-input
        v-model="dataSetup.triggerName"
        :error-required="$v.dataSetup.triggerName.$error"
        placeholder="Trigger name"
      />
    </b-form>
    <b-form :class="{'error-input' : $v.dataSetup.triggerEvent.$error}">
      <label>Event</label>
      <j-single-select
        v-model="dataSetup.triggerEvent"
        :error-required="$v.dataSetup.triggerEvent.$error"
        :options="eventOptions"
        :placeholder="'Select Event Type'"
        label="text"
      />
    </b-form>

    <div class="d-flex justify-content-end mt-4">
      <button
        class="button-border mr-2"
        @click="$emit('close-modal')"
      >
        Close
      </button>
      <button
        class="button-blue"
        @click="submitTrigger"
      >
        Create
      </button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
// Services
import jApiAutomation from '@/services/jApiAutomation';
// Validation
import { required } from 'vuelidate/lib/validators';

export default {
  props: {
    id: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      dataSetup: {
        triggerName: '',
        triggerEvent: null,
      },
      eventOptions: [
        {
          id: 'record_created',
          text: 'Record Created',
        },
        {
          id: 'record_updated',
          text: 'Record Updated',
        },
        {
          id: 'record_deleted',
          text: 'Record Deleted',
        },
        {
          id: 'record_approved',
          text: 'Record Approved',
        },
        {
          id: 'record_rejected',
          text: 'Record Rejected',
        },
        {
          id: 'record_submitted',
          text: 'Record Submitted',
        },
        {
          id: 'record_exported',
          text: 'Record Exported',
        },
        {
          id: 'record_closed',
          text: 'Record Closed',
        },
      ],
    };
  },

  computed: {
    ...mapState('jStoreForm', ['form_data']),
  },

  methods: {
    ...mapActions('jStoreNotificationScreen', ['toggleProblem', 'showLoading', 'hideLoading', 'toggleSuccess']),

    async submitTrigger() {
      this.$v.dataSetup.$touch();
      if (!this.$v.dataSetup.$error) {
        const payload = {
          actions: null,
          id: '',
          is_active: true,
          is_sync: false,
          name: this.dataSetup.triggerName,
          trigger: {
            api_v2: {},
            container_response: null,
            container_variable: null,
            dedicated_job: {},
            event: {},
            form: {
              event: this.dataSetup.triggerEvent,
              form_data_id: this.form_data.id,
              tablegroup_id: this.form_data.tablegroup_id,
            },
            function: {},
            job: {},
            scheduler: null,
            type: 'form',
            webhook_v2: {},
          },
        };
        this.showLoading();
        const res = await jApiAutomation.createAutomation(payload);
        if (res) {
          this.hideLoading();
          if (!res.error) {
            this.toggleSuccess(res.message);
            this.$router.push(`/visual-programming/${res.data.id}`);
          } else {
            this.toggleProblem(res.message);
          }
        }
      }
    },
  },

  validations() {
    return {
      dataSetup: {
        triggerName: { required },
        triggerEvent: { required },
      },
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/data-manager/jModalAddTrigger.vue